import { render, staticRenderFns } from "./articledetail.vue?vue&type=template&id=4dec6604&scoped=true&"
import script from "./articledetail.vue?vue&type=script&lang=js&"
export * from "./articledetail.vue?vue&type=script&lang=js&"
import style0 from "./articledetail.vue?vue&type=style&index=0&id=4dec6604&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec6604",
  null
  
)

export default component.exports